import { type ReactNode } from 'react';
import { PortalDashboardView } from './PortalDashboardView.js';

/**
 * M42 §27 AgencyPortalDashboard — the agency stakeholder landing surface (§17).
 * Renders the shared responsive dashboard view scoped to the AGENCY segment.
 */
export function AgencyPortalDashboard(): ReactNode {
  return <PortalDashboardView segment="Agency" defaultType="AGENCY" />;
}
